// advup — guarda pra usePwaAutoUpdate nunca recarregar a página no meio de
// uma gravação/conversão/envio de áudio (achado real 2026-07-30: Dra.
// Jullya gravou um áudio no PWA mobile, apertou pra enviar, e o app
// recarregou sozinho como se tivesse fechado e reaberto — perdendo a
// mensagem). Causa: `usePwaAutoUpdate` recarrega sem aviso assim que
// detecta um deploy novo, checando no `visibilitychange` ao voltar de
// segundo plano — e a conversão de áudio pra MP3 (`mp3ConversionUtils.js`)
// é síncrona e pesada o bastante pra jogar o WebView do iOS pra segundo
// plano por conta própria, disparando exatamente esse check na pior hora.
//
// Contador (não boolean) pra suportar múltiplas fontes de "ocupado" ao
// mesmo tempo sem uma liberar a guarda da outra.
let busyCount = 0;

export function markPwaBusy() {
  busyCount += 1;
}

export function markPwaIdle() {
  busyCount = Math.max(0, busyCount - 1);
}

export function isPwaBusy() {
  return busyCount > 0;
}
